import { CarouselView } from '@component/product-pool-media';
import CustomCarouselView from '../views/CustomCarouselView';

export default class CarouselViewDecider {
  static getCarouselView(panelConfig, properties, params) {
    const isProsReDesignEnabled = properties.prosZoneRedesignEnabled;

    if (properties.customProductThumbnailEnabled && isProsReDesignEnabled) {
      return new CustomCarouselView(params);
    }
    return new CarouselView(params);
  }
}
